import { render, staticRenderFns } from "./editArticulo.vue?vue&type=template&id=c8b8c1de&"
import script from "./editArticulo.vue?vue&type=script&lang=js&"
export * from "./editArticulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator,QInput,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSeparator,QInput,QBtn})
